import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from '../reducers/auth';
import eventReducer from '../reducers/events';
import spaceReducer from '../reducers/spaces';
import notificationReducer from '../reducers/notifications';
import promoterReducer from '../reducers/promoter';
import brandReducer from '../reducers/brands';
import bookingReducer from '../reducers/bookings';
import suggestionsReducer from '../reducers/suggestions';
import paymentsReducer from '../reducers/payments';
import preferencesReducer from '../reducers/preferences';
import helpReducer from '../reducers/help';

import { setupAxiosInterceptors } from '../../utils/axiosConfig';
import { bootstrapAuth } from '../actions/auth';

const rootReducer = combineReducers({
  auth: authReducer,
  events: eventReducer,
  spaces: spaceReducer,
  notifications: notificationReducer,
  promoter: promoterReducer,
  brands: brandReducer,
  bookings: bookingReducer,
  suggestions: suggestionsReducer,
  payments: paymentsReducer,
  preferences: preferencesReducer,
  help: helpReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

setupAxiosInterceptors(store);
store.dispatch(bootstrapAuth());

export default store;
